import React from "react";
import PropTypes from 'prop-types';

import { ReactComponent as Cross } from "assets/icons/cross-circle-filled.svg";
import { ReactComponent as Check } from "assets/icons/checkmark-circle-filled.svg";

export const sentiments = {
  positive: "+",
  negative: "-",
};

const settings = {
  [sentiments.positive]: {
    listClass: 'pros-cons__list pros-cons__pros',
    iconClass: 'icon-positive',
    icon: Check,
  },
  [sentiments.negative]: {
    listClass: 'pros-cons__list pros-cons__cons',
    iconClass: 'icon-negative',
    icon: Cross,
  },
};

export const SentimentList = ({reviews, sentiment}) => {
  const config = settings[sentiment];
  const Icon = config.icon;

  return (
    <ul className={config.listClass}>
      {reviews.map((text, index) => (
        <li key={index}>
            <span className={config.iconClass}>
              <Icon />
            </span>
            {text}
        </li>            
      ))}
    </ul>
  );
};

SentimentList.propTypes = {
  reviews: PropTypes.arrayOf(String).isRequired,
  sentiment: PropTypes.oneOf([sentiments.positive, sentiments.negative]).isRequired,
};